// ===================================================================
// KAIXO - CRMDashboard
// ===================================================================
// Vista 'dashboard' del CRM: KPIs principales + pipeline mini + CTA
// para crear nuevo lead + panel de aprendizaje del algoritmo.
// ===================================================================

import React from 'react';
import { Icons } from '../Icons/Icons';
import ConversionInsights from '../Impulsa/ConversionInsights';
import ct from './i18n';

export default function CRMDashboard({
    dashboard,
    loading,
    statusColors,
    onNewLead
}) {
    if (loading) return <p className="crm-center">{ct.loading}</p>;
    const db = dashboard || {};

    return (
        <>
            <div className="crm-kpis">
                <div className="crm-kpi">
                    <div className="crm-kpi-val">{db.total || 0}</div>
                    <div className="crm-kpi-label">{ct.total}</div>
                </div>
                <div className="crm-kpi">
                    <div className="crm-kpi-val" style={{ color: '#10B981' }}>{db.newToday || 0}</div>
                    <div className="crm-kpi-label">{ct.today}</div>
                </div>
                <div className="crm-kpi">
                    <div className="crm-kpi-val" style={{ color: '#059669' }}>{db.byStatus?.cerrado || 0}</div>
                    <div className="crm-kpi-label">{ct.converted}</div>
                </div>
                <div className="crm-kpi">
                    <div className="crm-kpi-val" style={{ color: '#00B4D8' }}>{db.conversionRate || 0}%</div>
                    <div className="crm-kpi-label">{ct.conversionRate}</div>
                </div>
            </div>
            <div className="crm-kpis">
                <div className="crm-kpi">
                    <div className="crm-kpi-val">${(db.convertedBudget || 0).toLocaleString()}</div>
                    <div className="crm-kpi-label">{ct.revenue}</div>
                </div>
                <div className="crm-kpi">
                    <div className="crm-kpi-val">${(db.avgBudget || 0).toLocaleString()}</div>
                    <div className="crm-kpi-label">{ct.avgDeal}</div>
                </div>
                <div className="crm-kpi">
                    <div className="crm-kpi-val">{db.agentsCount || 0}</div>
                    <div className="crm-kpi-label">{ct.agents}</div>
                </div>
                <div className="crm-kpi">
                    <div className="crm-kpi-val" style={{ color: '#EF4444' }}>{db.byStatus?.perdido || 0}</div>
                    <div className="crm-kpi-label">{ct.lost}</div>
                </div>
            </div>

            {/* Pipeline mini */}
            <div className="crm-pipeline-mini">
                {Object.entries(db.byStatus || {}).map(([status, count]) => (
                    <div
                        key={status}
                        className="crm-pipe-stage"
                        style={{ borderLeftColor: statusColors?.[status] || '#888' }}
                    >
                        <span className="crm-pipe-count">{count}</span>
                        <span className="crm-pipe-label">{ct.statuses?.[status] || status}</span>
                    </div>
                ))}
            </div>

            <button className="crm-btn-primary crm-btn-full" onClick={onNewLead}>
                <Icons.Plus size={16} color="white" /> {ct.newLead}
            </button>

            {/* Panel de aprendizaje del algoritmo */}
            <ConversionInsights />
        </>
    );
}
